import axios from 'axios'

const apiLgpd = axios.create({
  baseURL: `https://producao2.theos.com.br/EclesialLgpd/api/v1`
})

export default apiLgpd
